import React, { Fragment } from 'react';
import classNames from 'classnames';
import ToggleContainer from '../../Containers/toggleContainer';
import { isSmallViewport } from '../../Hooks/useMedia';
import ExpandableButton from '../../Buttons';

const Label = (props) => {
  if (!props.data) return null;

  return <dt>{props.label}</dt>;
};

const Value = (props) => {
  if (!props.data) return null;

  return <dd>{props.data}</dd>;
};

const ValueLink = (props) => {
  if (!props.data) return null;
  const matomoTrackingClass = 'hitta-oss';
  return (
    <dd>
      <a className={`find-us__webpage ${matomoTrackingClass}`} href={props.data}>
        <span>{props.data}</span>
      </a>
    </dd>
  );
};

const AccessibilityUrl = (props) => {
  if (!props.url) return null;
  const matomoTrackingClass = 'accessibilityurl';
  return (
    <dd>
      <a className={`${matomoTrackingClass}`} href={props.url}>
        <span>{props.text}</span>
      </a>
    </dd>
  );
};

const FindUs = (props) => {
  const Card = props;
  const isSmall = isSmallViewport();
  
  return (
    <div className="find-us">
      <div className="find-us__inner">
        <div className={props.wrapperClasses}>
          {Card.Location && Card.Location.latitude && Card.Location.longitude && (
            <div className={props.mapGrid}>
              <div className="find-us__map-wrapper">
                <div className="find-us__map-planner">
                  <a
                    className="find-us__map-planner__link"
                    href={`https://www.google.se/maps/dir/?api=1&destination=${Card.Location.latitude},${Card.Location.longitude}`}
                  >
                    <span>{Card.Translations.biggermaptravelplanner}</span>
                  </a>
                </div>

                {Card.StaticMapUrl && (
                  <img
                    className="find-us__map"
                    src={Card.StaticMapUrl}
                    alt=""
                  />
                )}
              </div>
            </div>
          )}
          <div className={props.addressGrid}>
            <dl className="find-us__address">
              {Card.Address && Card.Translations.visitoraddress && (
                <Fragment>
                  <Label
                    data={Card.Address}
                    label={Card.Translations.visitoraddress}
                  />
                  <Value data={Card.Address} />
                </Fragment>
              )}

              {Card.County && Card.Translations.county && (
                <Fragment>
                  <Label data={Card.County} label={Card.Translations.county} />
                  <Value
                    data={`${Card.County}${
                      Card.Municipality ? ', ' + Card.Municipality : ''
                    }`}
                  />
                </Fragment>
              )}

              {Card.PostalAddress && Card.Translations.postaladdress && (
                <Fragment>
                  <Label
                    data={Card.PostalAddress}
                    label={Card.Translations.postaladdress}
                  />
                  <Value data={Card.PostalAddress} />
                </Fragment>
              )}

              {Card.WebsiteUrl && Card.Translations.websiteurl && (
                <Fragment>
                  <Label
                    data={Card.WebsiteUrl}
                    label={Card.Translations.websiteurl}
                  />
                  <ValueLink data={Card.WebsiteUrl} />
                </Fragment>
              )}

              {Card.AccessibilityUrl && Card.Translations.accessibilityurl && (
                <Fragment>
                  <Label
                    data={Card.AccessibilityUrl}
                    label={Card.Translations.accessibilityurl}
                  />
                  <AccessibilityUrl url={Card.AccessibilityUrl} text={Card.AccessibilityUrlText} />
                </Fragment>
              )}
            </dl>
          </div>
        </div>
      </div>
      <div>
        <ToggleContainer open={isSmall ? true : undefined}>
          {({ open, toggle }) => (
            <div
              className={classNames({
                'extended-info': true,
                'extended-info--is-open': open,
              })}
            >
              {!isSmall &&
                (Card.IndoorRouteDescription || Card.RoadDescription) && (
                  <h3>
                    <ExpandableButton
                      onClick={toggle}
                      open={open}
                      buttonClass="find-us__toggle-button"
                      iconClass="plus--extended-info"
                      buttonText={
                        open
                          ? Card.Translations.hideroutedescription
                          : Card.Translations.showroutedescription
                      }
                      buttonId="indoor-route-description"
                      textClass="find-us__toggle-button__text"
                    />
                  </h3>
                )}
              <div
                className={classNames({
                  'extended-info__content': true,
                  visible: open,
                })}
              >
                {(Card.IndoorRouteDescription || Card.RoadDescription) && (
                  <div>
                    <h3 className="extended-info__heading">
                      {Card.Translations.roaddescription}
                    </h3>
                    {Card.RoadDescription && (
                      <div className="outdoor-description">
                        <h4>{Card.Translations.outdoorroutedescription}</h4>
                        {Card.RoadDescription.map((description, index) => (
                          <p key={index}>{description}</p>
                        ))}
                      </div>
                    )}
                    {Card.IndoorRouteDescription && (
                      <div className="indoor-description">
                        <h4>{Card.Translations.indoorroutedescription}</h4>
                        {Card.IndoorRouteDescription.map(
                          (description, index) => (
                            <p key={index}>{description}</p>
                          )
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </ToggleContainer>
      </div>
    </div>
  );
};

FindUs.defaultProps = {
  wrapperClasses: 'row',
  mapGrid: 'columns large-6 large-push-6',
  addressGrid: 'columns large-6',
};

export default FindUs;
